import type {
  AccountantReference,
  AdditionalSubject,
  IncomeAccountantReference,
  IncomeEmployerReference,
} from '@/types/Activity'
import type { AddressLandlordReference } from '@/types/Landlord'

export const hasExpired = (
  reference?:
    | IncomeEmployerReference
    | AccountantReference
    | IncomeAccountantReference
    | AddressLandlordReference,
): boolean => reference?.outcome?.status === 'Expired'

export const hasCompletedBotJourney = (
  reference?:
    | IncomeEmployerReference
    | AccountantReference
    | IncomeAccountantReference
    | AddressLandlordReference,
): boolean =>
  reference?.outcome?.status !== 'Pending' && reference?.outcome?.status !== 'Expired'

export const getReferencedApplicantSubjectId = (
  attachedSubjects?: AdditionalSubject[],
): string | undefined => {
  if (attachedSubjects && attachedSubjects[0]) {
    return attachedSubjects[0].subjectId
  }
}
